<!--
Created by CHT 2020/10/14 10:06
-->
<template>
  <div>
    <van-cell class="ry-form__single-line" v-if="isNormalStyle">
      <template slot="title">
        <span class="title">{{current.title}}</span>
        <span style="color: red" v-if="!isRead && current.required">*</span>
      </template>
      <template slot="label">

        <template v-if="current.fieldHint">
          <froalaView v-if="$store.getters.newRtf" v-model="current.fieldHint"></froalaView>
          <div
            v-else
            class="ql-editor"
            v-html="current.fieldHint">
          </div>
        </template>
        <div
          v-if="isRead"
          v-html="content">
        </div>
        <van-field
          :class="{'btn' : current.triggerType === TRIGGER_TYPE_BUTTON}"
          v-if="!isRead"
          :readonly="isReadOnly || onlyScan"
          v-model="currentRow[dataId]"
          @blur="inputBlur"
          @focus="inputFocus"
          :placeholder="current.fieldDes"
          :error-message="errorMessage">
          <van-icon
            class="scan"
            v-if="current.scanSwitch"
            slot="button"
            @click="openScan"
            size="20"
            name="scan">
          </van-icon>
          <van-button
            v-if="current.triggerType === TRIGGER_TYPE_BUTTON"
            slot="button"
            size="small"
            style="color: #ffffff;"
            :loading="loading"
            :style="{backgroundColor: current.buttonColor, borderColor: current.buttonColor}"
            @click="onClickBtn"
            type="primary">
            {{current.buttonName}}
          </van-button>
        </van-field>
      </template>
    </van-cell>

    <div v-else class="ry-form-item-compact ry-form__single-line-compact">

      <van-field
        v-if="isRead"
        :label="current.title"
        :required="Boolean(!isRead && current.required)">
        <template #input>
          <div
            v-html="content">
          </div>
        </template>
      </van-field>

      <van-field
        :class="{'btn' : current.triggerType === TRIGGER_TYPE_BUTTON}"
        v-if="!isRead"
        :label-class="{'readonly-field-label': isReadOnly}"
        :readonly="isReadOnly || onlyScan"
        v-model="currentRow[dataId]"
        @blur="inputBlur"
        @focus="inputFocus"
        :placeholder="current.fieldDes || isReadOnly ? '暂无内容' : '请填写内容'"
        :label="current.title"
        :required="Boolean(!isRead && current.required)">
        <van-icon
          class="scan"
          v-if="current.scanSwitch"
          slot="button"
          @click="openScan"
          size="20"
          name="scan">
        </van-icon>
        <van-button
          v-if="current.triggerType === TRIGGER_TYPE_BUTTON"
          slot="button"
          size="small"
          style="color: #ffffff;"
          :loading="loading"
          :style="{backgroundColor: current.buttonColor, borderColor: current.buttonColor}"
          @click="onClickBtn"
          type="primary">
          {{current.buttonName}}
        </van-button>
      </van-field>
    </div>

    <RySelectPopup
      v-if="current.pluginConfig && current.pluginConfig.entryId"
      ref="rySelectPopup"
      :title="current.title"
      @selectComplete="selectComplete">
    </RySelectPopup>
  </div>

</template>

<script>
  import { current } from './mixin'
  import {TRIGGER_TYPE_BLUR, TRIGGER_TYPE_FOCUS, TRIGGER_TYPE_BUTTON} from "../../types";
  import {selectPhoneNumberAndUrl} from "../../../../assets/js/Untis";

  export default {
    mixins: [current],
    data () {
      return {
        TRIGGER_TYPE_BUTTON,
        isError: false,
        oldValue: ''
      }
    },
    computed: {
      content() {
        const value = selectPhoneNumberAndUrl(this.currentRow[this.current.dataId])
        return this.currentRow[this.current.dataId] ? value : '暂无内容'
      },
      checkList () {
        return this.current.checkList()
      },
      errorMessage () {
        return this.isError ? '输入数据不合法' : ''
      },
      onlyScan () {
        // 扫码已开 并且 扫码结果不可修改
        return Boolean(this.current.scanSwitch && !this.current.scanEdit)
      }
    },
    created(){
      this.oldValue = this.current.value
    },
    methods: {
      // Input 失去焦点时触发
      inputBlur () {
        this.isError = this.current.checkMissValue && (!this.current.checkWriteValue() || !this.checkList)

        if (this.current.triggerType === TRIGGER_TYPE_BLUR && this.oldValue !== this.current.value) {
          this.submitData()
        }
        this.oldValue = this.current.value
        this.controlChange()
      },
      // Input 获得焦点时触发
      inputFocus() {
        if (this.current.triggerType === TRIGGER_TYPE_FOCUS && this.oldValue !== this.current.value) {
          this.submitData()
        }
      },
      // 打开扫码
      openScan () {
        if (window.isWexin || window.isWxWork) {
          this.wxScan()
        } else if (window.isLark) {
          this.larkScan()
        } else if (window.isDingtalk) {
          this.dingScan()
        }
      },

      wxScan() {
        let scanType = ['barCode']
        if (this.current.scanType) {
          scanType = ['qrCode']
        }
        this.$wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType, // 可以指定扫二维码还是一维码，默认二者都有
          success: (res) => {
            if(scanType[0] === 'barCode') {
              this.currentRow[this.dataId] = res.resultStr.split(',')[1]
            } else {
              this.currentRow[this.dataId] = res.resultStr
            }
            this.submitData()
            this.controlChange()
          },
          fail: err => {
            console.log(err)
          }
        })
      },

      larkScan() {
        this.$tt.ready(() => {
            let scanType = ['barCode']
            if (this.current.scanType === 1) {
              scanType = ['qrCode']
            } else if (this.current.scanType === 2) {
              scanType = ['qrCode','barCode']
            }
            console.log('larkScan--', this.$tt, tt, scanType)
            window.h5sdk.ready(() => {
              console.log('larkScan--ready-', tt)
              tt.scanCode({
                scanType: scanType,
                barCodeInput: true,
                success: (res) => {
                  console.log('larkScan--success-', res)
                  this.currentRow[this.dataId] = res.result
                  this.submitData()
                  this.controlChange()
                },
                fail: (err) => {
                  console.log('larkScan--fail-', JSON.stringify(err))
                }
              });

            });
          // let scanType = 'barCode'
          // if (this.current.scanType) {
          //   scanType = 'qrCode'
          // }
          // this.$tt.biz.util.scan({
          //   type: scanType,
          //   onSuccess: result => {
          //     console.log('larkScan--',result)
          //     if (scanType === 'barCode') {
          //       this.currentRow[this.dataId] = result.resultStr.split(',')[1]
          //     } else {
          //       this.currentRow[this.dataId] = result.resultStr
          //     }
          //     this.controlChange()
          //   },
          //   onFail: errorMsg => {
          //     console.log('larkScan--error',errorMsg)
          //   }
          // });

        })
      },

      dingScan() {
        console.log('dingScan', this.$dd)

        let scanType = 'barCode'
        if (this.current.scanType === 1) {
          scanType = 'qrCode'
        } else if (this.current.scanType === 2) {
          scanType = 'all'
        }
        this.$dd.ready(() => {
          console.log('dingScan--ready')
          // dd.ready参数为回调函数，在环境准备就绪时触发，jsapi的调用需要保证在该回调函数触发后调用，否则无效。
          this.$dd.biz.util.scan({
            type: scanType , // type 为 all、qrCode、barCode，默认是all。
            onSuccess: data => {
              //onSuccess将在扫码成功之后回调
              /* data结构
                { 'text': String}
              */
              this.currentRow[this.dataId] = data.text
              this.submitData()
              this.controlChange()
              console.log('onSuccess', data)
            },
            onFail : function(err) {
            }
          })
        });
      },

      onClickBtn() {
        console.log('onClickBtn', this.current.pluginConfig)
        if (this.current.showAlert) {
          this.$dialog.confirm({
            title: '确认信息',
            message: this.current.alertText,
          })
            .then(() => {
              // on confirm
              this.submitData()
            })
            .catch(() => {
              // on cancel
            });
        } else {
          this.submitData()
        }
      },
    }
  }
</script>

<style lang="less">

  .ry-form__single-line {

    .btn {
      padding: 0 !important;

      .van-field__body {
        margin-right: 0 !important;

        .scan {
          margin-right: 10px;
        }

        .van-field__button {
          height: auto;
          display: flex;
          align-items: center;
        }
      }
    }
  }
</style>